import React from "react";
import "./cookin.scss";

const Cookin = ({ title, description }) => {
  return (
    <>
      <div className="cookin_sec1">
        <div className="my_container">
          <div className="text_container">
            <p className="desc">{description}</p>
            <h6 className="title">{title}</h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cookin;
